<script>
  import CurrencyMixin from "../mixins/CurrencyMixin";

  export default {
    props: ['value'],

    mixins: [CurrencyMixin],

    computed: {
      currency() {
        return this.format(this.value);
      }
    }
  }
</script>
<template>
  <span :class="{'font-red-intense' : value < 0}">{{ currency }}</span>
</template>



// WEBPACK FOOTER //
// resources/vue/components/CurrencyText.vue